import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import "../../styles/sidebar/sidebar.css";
import Header from "../../components/header/Header";
import RecordedDataComponent from "../../components/recordedData/RecordedDataComponent";
import ScannerOperatorsComponent from "../../components/recordedData/ScannerOperatorsComponent";

const CoordinatorScannerOperators = () => {
  return (
    <>
      <div className="recorded-data-container">
        <Sidebar role="coordinator" />
        <div className="main-content">
          <Header />
          <ScannerOperatorsComponent/>
        </div>
      </div>
    </>
  );
};

export default CoordinatorScannerOperators;
